import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export function useScenarioBox(flashcard) {
  const store = useStore();
  const route = useRoute();

  const scenarioBoxGrouping = computed(() => {
    if (!flashcard.value?.id) return undefined;
    return store.getters['groupings/list'].find(grouping => {
      return grouping?.groupingType === 'Scenario Box'
        && grouping?.assetAssociations.find(aa => flashcard.value.id === aa.assetBId);
    });
  });

  const scenarioBoxTopicId = computed(() => {
    if (!flashcard.value?.id) return undefined;
    if (route.name.includes('scenario')) {
      const grouping = store.getters['groupings/list'].find(grouping => {
        return grouping?.productAssociations.find(pa => pa.categoryId === parseInt(route.params.categoryId));
      });
      const isFlashcardAssociated = grouping?.assetAssociations.find(aa => flashcard.value.id === aa.assetBId);
      if (grouping?.groupingType === 'Scenario Box' && isFlashcardAssociated) {
        const scenarioBoxTopicAssociation = grouping.assetAssociations.find(aa => aa.assetBType === 'Topic');
        return scenarioBoxTopicAssociation?.assetBId;
      }
    } else if (scenarioBoxGrouping.value) {
      const scenarioBoxTopicAssociation = scenarioBoxGrouping.value.assetAssociations.find(aa => aa.assetBType === 'Topic' && aa.displayType === 'scenario_box');
      return scenarioBoxTopicAssociation?.assetBId;
    } else {
      const flashcardAssociation = flashcard.value.assetAssociations?.find(aa => aa.assetBType === 'Topic' && aa.displayType === 'scenario_box');
      return flashcardAssociation?.assetBId;
    }
  });

  watch(scenarioBoxTopicId, (id) => {
    if (id) {
      store.dispatch('topics/load', { ids: [id] });
    }
  }, { immediate: true });

  const scenarioBoxTopic = computed(() => {
    if (!scenarioBoxTopicId.value) return undefined;
    return store.getters['topics/topics'][`${scenarioBoxTopicId.value}`];
  });

  const hasScenarioBox = computed(() => !!scenarioBoxTopic.value);

  return { scenarioBoxTopic, hasScenarioBox };
}

export function isScenarioReviewRoute(route) {
  return route.name === 'scenarios#review';
}
